import { useMutation, useQuery, useQueryClient } from "react-query";
import { OrganizationKeyName } from "../../../model/Organization";
import { packingItemsHttp } from "./packing-items-http";
import { PackingItem } from "../models/packing-item";

export const packingItemsCacheKeys = {
  packingItems: "packingItems",
  packingItem: "packingItem",
};

export const useListPackingItems = (
  organizationKeyName: OrganizationKeyName
) => {
  return useQuery(
    [packingItemsCacheKeys.packingItems, organizationKeyName],
    () => packingItemsHttp.getPackingItems(organizationKeyName),
    { refetchOnWindowFocus: false }
  );
};

export const useGetPackingItem = (
  organizationKeyName: OrganizationKeyName,
  id?: string
) => {
  return useQuery<PackingItem | undefined, any>(
    [packingItemsCacheKeys.packingItem, id],
    () => packingItemsHttp.getPackingItem(organizationKeyName, id),
    { refetchOnWindowFocus: false, enabled: !!id }
  );
};

export const useDeletePackingItem = () => {
  const queryClient = useQueryClient();

  return useMutation(packingItemsHttp.deletePackingItem, {
    onSuccess: async () => {
      await queryClient.refetchQueries(packingItemsCacheKeys.packingItems);
    },
  });
};

export const useUpdatePackingItem = (id?: string) => {
  const queryClient = useQueryClient();

  return useMutation(packingItemsHttp.updatePackingItem, {
    onSuccess: async () => {
      await queryClient.refetchQueries(packingItemsCacheKeys.packingItems);
      if (id) {
        await queryClient.refetchQueries([
          packingItemsCacheKeys.packingItem,
          id,
        ]);
      }
    },
  });
};

export const useCreatePackingItem = () => {
  const queryClient = useQueryClient();

  return useMutation(packingItemsHttp.createPackingItem, {
    onSuccess: async () => {
      await queryClient.refetchQueries(packingItemsCacheKeys.packingItems);
    },
  });
};

export const useUpdatePackingItemSorting = () => {
  const queryClient = useQueryClient();

  return useMutation(packingItemsHttp.updatePackingItemSorting, {
    onSuccess: async () => {
      await queryClient.refetchQueries(packingItemsCacheKeys.packingItems);
    },
  });
};
